export const getCookieStorageDomain = (hostname = window.location.hostname) => {
  const normalizedHostname = hostname.toLowerCase();

  if (
    normalizedHostname === "localhost" ||
    normalizedHostname.endsWith(".localhost")
  ) {
    return ".localhost";
  }

  if (
    normalizedHostname === "teams.operto.com" ||
    normalizedHostname.endsWith(".teams.operto.com")
  ) {
    return ".teams.operto.com";
  }

  if (
    normalizedHostname === "teams.operto-qa.com" ||
    normalizedHostname.endsWith(".teams.operto-qa.com")
  ) {
    return ".teams.operto-qa.com";
  }

  return normalizedHostname;
};

const getLegacyCookieStorageDomains = (hostname = window.location.hostname) => {
  const normalizedHostname = hostname.toLowerCase();

  if (
    normalizedHostname === "operto-qa.com" ||
    normalizedHostname.endsWith(".operto-qa.com")
  ) {
    return [".operto-qa.com"];
  }

  if (
    normalizedHostname === "operto.com" ||
    normalizedHostname.endsWith(".operto.com")
  ) {
    return [".operto.com"];
  }

  return [];
};

const isCognitoCookieName = (cookieName) =>
  cookieName.startsWith("CognitoIdentityServiceProvider") ||
  cookieName.endsWith(".idToken") ||
  cookieName.endsWith(".accessToken") ||
  cookieName.endsWith(".refreshToken") ||
  cookieName.endsWith(".LastAuthUser") ||
  cookieName.endsWith(".clockDrift") ||
  cookieName.endsWith(".userData");

export const expireLegacyCognitoCookies = () => {
  const domains = getLegacyCookieStorageDomains();
  if (!domains.length) return;

  const cookies = document.cookie
    ? document.cookie.split(";").map((cookie) => cookie.trim()).filter(Boolean)
    : [];

  cookies.forEach((cookie) => {
    const cookieName = cookie.split("=")[0];
    if (!cookieName || !isCognitoCookieName(cookieName)) return;

    domains.forEach((domain) => {
      document.cookie = `${cookieName}=; Path=/; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    });
  });
};
